<template>
  <el-dialog
    width="66%"
    center
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    @close="handleClose"
    class="crm-client-info-dialog"
  >
    <el-row>
      <el-col :span="12" class="kbs-crm-client">
        <el-form
          class="top"
          ref="clientForm"
          :model="clientInfoForm"
          label-position="right"
          label-width="130px"
          :rules="ruleValidate"
        >
          <el-form-item label="姓名" prop="nameCn" class="kbs-short-input kbs-r-error">
            <el-input
              v-if="editAuth"
              :ref="'inputname'"
              type="text"
              v-model="clientInfoForm.nameCn"
              placeholder="请输入名称"
            ></el-input>
            <span v-else>{{ clientInfoForm.nameCn }}</span>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone" class="kbs-short-input kbs-r-error">
            <el-input
              v-if="editAuth"
              :ref="'inputtel'"
              type="text"
              v-model="clientInfoForm.phone"
              placeholder="请输入联系电话"
            ></el-input>
            <span v-else>{{ clientInfoForm.phone }}</span>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" class="kbs-short-input">
            <el-input
              v-if="editAuth"
              :ref="'inputemail'"
              type="text"
              v-model="clientInfoForm.email"
              placeholder="请输入邮箱"
            ></el-input>
            <span v-else>{{ clientInfoForm.email }}</span>
          </el-form-item>
          <el-form-item label="地址" class="kbs-short-input kbs-textarea" prop="addr">
            <el-input
              v-if="editAuth"
              :ref="'inputadress'"
              type="textarea"
              v-model="clientInfoForm.addr"
              placeholder="请输入客户地址"
              resize="none"
            ></el-input>
            <span v-else>{{ clientInfoForm.addr }}</span>
          </el-form-item>
          <el-form-item label="标签" class="kbs-label-form" :class="editAuth?'':'crm-unedit'">
            <el-tag
              :closable="editAuth? true:false"
              v-for="item in clientInfoForm.labelRespList"
              :key="item.id"
              @close="handleLabelClose(item)"
            >{{ item.name }}</el-tag>
            <el-button v-if="editAuth" class="button-new-tag" size="small" @click="handleAddLabel">+</el-button>
          </el-form-item>
          <el-form-item label="创建时间" prop="createDate" class="kbs-short-input">
            <span>{{ clientInfoForm.createDate }}</span>
          </el-form-item>
          <el-form-item label="更新时间" prop="modifyDate" class="kbs-short-input">
            <span>{{ clientInfoForm.modifyDate }}</span>
          </el-form-item>
          <el-form-item
            v-for="(col,idx) in customizeList"
            :key="col.nameEn+col.name"
            :label="col.name"
            :prop="col.nameEn"
            class="kbs-short-input"
          >
            <span v-if="editAuth">
              <div v-if="col.styleType === 'radio'" class="crm-search">
                <el-select v-model="customizeList[idx]['value']" value-key="idx">
                  <el-option
                    v-for="item in customizeList[idx][col.nameEn + 'list']"
                    :key="item.id"
                    :label="item.val"
                    :value="item.val"
                  />
                </el-select>
              </div>
              <div v-if="col.styleType === 'number'" class="crm-search">
                <el-input
                  clearable
                  class="crm-input"
                  type="number"
                  v-model="customizeList[idx]['value']"
                ></el-input>
              </div>
              <div v-if="col.styleType === 'datatimepicker'">
                <el-date-picker
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="customizeList[idx]['value']"
                  type="datetime"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </div>
              <el-input
                v-if="col.styleType === 'textfield'"
                class="crm-search"
                type="text"
                v-model="customizeList[idx]['value']"
                placeholder="请输入..."
              ></el-input>
            </span>
            <span v-else>{{ customizeList[idx]['value'] }}</span>
          </el-form-item>
          <el-form-item v-if="editAuth" class="crm-save">
            <el-tag class="kbs-tag-cancle-conect" @click="handleUpdate">保存更新</el-tag>
          </el-form-item>
        </el-form>
        <div class="crm-info">
          <div class="crm-info-title">在线场景信息</div>
          <el-form label-position="right" label-width="130px">
            <el-form-item label="首次会话时间" prop="nameCn" class="kbs-short-input">
              <span>{{clientInfoForm.conversationFirst}}</span>
            </el-form-item>
            <el-form-item label="最后一次会话时间" prop="endTime" class="kbs-short-input">
              <span>{{clientInfoForm.conversationLast}}</span>
            </el-form-item>
          </el-form>
          <div class="crm-info-title">呼叫场景信息</div>
          <el-form label-position="right" label-width="130px">
            <el-form-item label="首次电联时间" prop="nameCn" class="kbs-short-input">
              <span>{{clientInfoForm.telConnFirst}}</span>
            </el-form-item>
            <el-form-item label="最后一次电联时间" prop="endTime" class="kbs-short-input">
              <span>{{clientInfoForm.telConnLast}}</span>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="12" class="kbs-collapse-visit">
        <el-collapse v-model="activeName">
          <el-collapse-item name="服务详情">
            <template slot="title">
              <div>服务详情</div>
            </template>
            <SessionListPanel :visitId="visitId" />
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
    <!-- 添加标签弹窗 -->
    <AddLabelModal
      v-if="modalVisible && editAuth"
      :checkedLabelIds="checkedLabelIds"
      @closeAddLabelModel="closeAddLabelModel"
    />
  </el-dialog>
</template>
<script>
import AddLabelModal from './AddLabel'
import SessionListPanel from './SessionListPanel'
import {
  delCustomerLabel,
  saveCustomerLabel,
  saveClient
} from '@/api/crm/widgets'
import { getCustomerDetail } from '@/api/crm/clientInfo'
import { Message } from 'element-ui'

export default {
  components: { AddLabelModal, SessionListPanel },
  props: {
    curRowId: {
      require: true,
      type: String,
      default: ''
    },
    customizeList: {
      type: Array,
      default() {
        return []
      }
    },
    editAuth: {
      require: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
        // return callback()
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('手机号格式不正确')
      } else {
        callback()
      }
    }
    const validLen = (rule, value, callback) => {
      // 地址不能超过50个汉字
      if (value && this.getByteLen(value.trim()) > 100) {
        callback(new Error('您输入的地址过长,请控制在50个字以内'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: true,
      dialogTitle: '客户信息',
      ruleValidate: {
        email: [
          {
            type: 'email',
            message: '邮箱格式错误',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            type: 'number',
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        addr: [
          {
            validator: validLen,
            trigger: ['blur', 'change']
          }
        ]
      },
      clientInfoForm: { labelRespList: [] },
      modalVisible: false,
      checkedLabelIds: [],
      visitId: '',
      mould: 3001,
      activeName: '服务详情'
    }
  },
  created() {
    this.getCustomerInfo()
  },
  methods: {
    getCustomerInfo() {
      getCustomerDetail(this.curRowId).then(res => {
        this.clientInfoForm = res.data
        this.visitId = this.clientInfoForm.visitId
        // 将客户的自定义字段信息展示出来
        for (const i in this.clientInfoForm) {
          this.customizeList.forEach((item, idx) => {
            if (item.nameEn === i) {
              this.$set(
                this.customizeList[idx],
                'value',
                this.clientInfoForm[i]
              )
            }
          })
        }
      })
    },
    getByteLen(val) {
      var len = 0
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i)
        // eslint-disable-next-line no-control-regex
        if (a.match(/[^\x00-\xff]/gi) != null) {
          len += 2
        } else {
          len += 1
        }
      }
      return len
    },
    handleClose() {
      this.$emit('closeClientInfoDialog')
    },
    handleUpdate() {
      this.handleSave()
    },
    // 关闭客户标签弹窗并保存标签
    closeAddLabelModel(labelList) {
      if (labelList) {
        // 删除被去除的标签
        this.clientInfoForm.labelRespList.forEach((item, idx) => {
          const labelListIds = labelList.map(item => {
            if (item.checked) {
              return item.id
            }
          })
          if (!labelListIds.includes(item.id)) {
            this.handleLabelClose(item)
          }
        })
        // 去除重复添加的标签
        labelList.forEach(item => {
          const exsitIds = this.clientInfoForm.labelRespList.map(
            item => item.id
          )
          const flag = !exsitIds.includes(item.id)
          if (item.checked && flag) {
            this.clientInfoForm.labelRespList.push(item)
          }
        })
      }
      this.modalVisible = false
      const options = {
        customerId: this.clientInfoForm.id,
        labelIds: this.clientInfoForm.labelRespList.map(item => item.id),
        mould: this.mould
      }
      saveCustomerLabel(options).then(res => {
        // console.log('res', res)
      })
    },
    handleAddLabel() {
      this.checkedLabelIds = this.clientInfoForm.labelRespList.map(
        item => item.id
      )
      this.modalVisible = true
    },
    handleLabelClose(item) {
      this.clientInfoForm.labelRespList.forEach((tag, index) => {
        if (tag.id === item.id) {
          this.clientInfoForm.labelRespList.splice(index, 1)
        }
      })
      const options = {
        customerId: this.clientInfoForm.id,
        labelIds: [item.id],
        mould: this.mould
      }
      delCustomerLabel(options).then(res => {
        // console.log('delres', res)
      })
    },
    handleSave() {
      this.customizeList.forEach(item => {
        this.clientInfoForm[item.nameEn] = item.value
      })
      this.$refs.clientForm.validate(valid => {
        if (valid) {
          this.clientInfoForm.mould = this.mould
          saveClient(this.clientInfoForm).then(res => {
            if (res.code === '2000') {
              Message.success('保存更新成功!')
              this.getCustomerInfo()
            } else {
              Message.error('保存失败!')
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.pl20 {
  padding-left: 20px;
}
.kbs-collapse {
  padding: 0 0 0 20px;
}
.kbs-visitor-step {
  line-height: 45px;
  border-bottom: 1px solid #ebeef5;
  font-size: 14px;
}
.el-form-item {
  margin-bottom: 10px;
}
.kbs-crm-client {
  height: 82vh;
  overflow: auto;
}
.kbs-crm-client .crm-save {
  margin-top: 30px;
  margin-bottom: 0px;
}
.kbs-short-input .el-input {
  width: 70%;
}
.kbs-short-input .el-select {
  width: 70%;
}
.kbs-short-input .el-textarea {
  width: 70%;
}
.iconsearchicon:hover {
  color: blue;
}
.kbs-icon-tel {
  cursor: pointer;
  position: absolute;
  padding: 0px 7px;
  right: 26px;
  top: 0;
  border-right: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
}
.kbs-icon-edit {
  cursor: pointer;
  position: absolute;
  padding: 0px 7px;
  right: -4px;
  top: 1px;
}
.kbs-tag-cancle-conect {
  cursor: pointer;
  background-color: #fff;
  padding: 0 !important;
  margin: 0 !important;
}
.crm-info .crm-info-title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
}
</style>
<style lang="scss">
.crm-client-info-dialog .el-dialog {
  margin-top: 9vh !important;
  margin: 0 auto;

  .el-input__icon.el-icon-time {
    display: none !important;
  }
  .kbs-collapse-visit .el-collapse-item__header {
    padding-left: 20px;
  }
  .kbs-collapse-visit .el-collapse-item__content {
    padding-bottom: 0px;
  }
  .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 0;
  }
  .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 15px;
  }
}
.kbs-crm-client .kbs-textarea .el-form-item__content .el-form-item__error {
  top: 101%;
}
.kbs-crm-client .kbs-r-error .el-form-item__content .el-form-item__error {
  top: 50%;
  padding-top: 0;
  left: 73%;
  transform: translateY(-50%);
}
.kbs-crm-client .el-tabs__header {
  margin: 0;
}
.kbs-crm-client .el-tag {
  display: inline-block;
  text-align: right;
  position: relative;
  height: 24px;
  margin: 3px 12px 2px 0;
  padding: 0px 10px;
  line-height: 20px;
  border: none;
}
.kbs-crm-client .crm-unedit .el-tag {
  margin: 0px 12px 2px 0;
  line-height: 23px;
}
.kbs-crm-client .crm-unedit .el-form-item__content {
  line-height: 30px;
}
.kbs-crm-client .el-tag .el-icon-close {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #d8e0dc;
  color: #9fb0c4;
  font-size: 12px !important;
}
.kbs-crm-client .button-new-tag {
  padding: 0px 0px !important;
  margin-left: 5px;
  margin-top: 2px;
  background-color: #f8f8f8;
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.kbs-crm-client .button-new-tag span {
  color: #b0b7bf;
  font-size: 18px;
  line-height: 18px;
}
.kbs-crm-client .kbs-search-form.el-form {
  padding-top: 6px;
  background: #fafafa;
  height: 36px;
  border-bottom: 1px solid #e7e8ec;
}
.kbs-crm-client .el-form {
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.kbs-crm-client .el-form-item__label {
  height: auto !important;
  /*line-height: 22px !important;*/
}
.kbs-crm-client .el-form-item__label,
.kbs-crm-client .kbs-short-input .el-form-item__content,
.kbs-crm-client .kbs-short-input input,
.kbs-crm-client .el-input__icon {
  height: 30px;
  line-height: 30px;
}
.kbs-crm-client .kbs-short-input.kbs-textarea .el-form-item__content {
  height: 50px;
  margin-bottom: 0;
}
.kbs-crm-client .kbs-short-input.kbs-textarea {
  height: 65px;
  margin-bottom: 0;
}
.kbs-client-desc {
  // border-top: 1px solid #e8eaec;
  // border-bottom: 1px solid #e8eaec;
  padding: 5px 0;
}
.kbs-client-desc .el-textarea__inner {
  height: 30px !important;
  width: 70%;
}
</style>
